const data_locale = {

    home: {
        ar: 'الرئيسية',
        en: 'Home'
    },
    about: {
        ar: 'خذ العلم منا',
        en: 'Get to know us'
    },
    about_description: {
        ar: "نحن هي شركة تسويق بالمؤثرين في المملكة العربية السعودية. نقدم خدمات التسويق بالمؤثرين للعلامات التجارية والشركات لتعزيز علامتها التجارية وتحقيق نتائج أفضل.",
        en: "We are an influencer marketing company in Saudi Arabia. We offer influencer marketing services to brands and companies to enhance their brand and achieve better results."
    },
    influencer_marketing: {
        ar: ' الإعلانات مع المؤثرين',
        en: 'Influencer Marketing'
    },
    services: {
        ar: 'أنظمة النمو',
        en: 'Our Services'
    },
    services_description: {
        ar: "نقدم حلول إبداعية تميز العلامات التجارية وتخليها تكبر بثقة وتترك بصمتها.",
        en: "We provide creative solutions that help brands stand out and grow with confidence."
    },
    services_growth_title: {
        ar: "أنظمة النمو والخدمات",
        en: "Growth & Service Systems"
    },
    services_growth_subtitle: {
        ar: "حلول تسويقية إبداعية بخبرات متراكمة تميّز العلامات التجارية وتصنع لها اثر وتموضع وحضور وثقة وتترك بصمتها",
        en: "Creative marketing solutions backed by proven expertise that set brands apart, building impact, positioning, presence, and trust, and leaving a lasting mark."
    },
    services_method_word_1: {
        ar: "بصيرة",
        en: "Insight"
    },
    services_method_word_2: {
        ar: "إبداع",
        en: "Creativity"
    },
    services_method_word_3: {
        ar: "تأثير",
        en: "Impact"
    },
    skip_services: {
        ar: "تخطي القسم",
        en: "Skip Section"
    },
    services_cta_label: {
        ar: "جاهز تبدأ؟",
        en: "Ready to get started?"
    },

    works: {
        ar: ' اعمالنا',
        en: 'Our Work'
    },
    works_growth_title: {
        ar: "بعض أعمالنا",
        en: "Some of Our Work"
    },
    works_growth_subtitle: {
        ar: "نخبة من المشاريع اللي تعكس الأسلوب الإبداعي\nنحرص على تقديم منظومة عمل تترك نمو وأثر",
        en: "A selection of projects that reflect our creative style\nwe're committed to delivering work that leaves growth and impact behind."
    },
    works_description: {
        ar: 'نخبة من مشاريعنا اللي تعكس أسلوبنا الإبداعي وحرصنا على تقديم جودة تترك أثر.',
        en: 'A showcase of the projects we’ve crafted with passion and precision. Explore how we bring ideas to life through design, strategy, and creativity.'
    },

    our_location: {
        ar: 'موقعنا',
        en: 'Our Location'
    },
    our_location_description: {
        ar: 'قم بزيارتنا في مقرنا بالرياض، واستكشف موقعنا بتقنية الخرائط ثلاثية الأبعاد.',
        en: 'Visit us at our office in Riyadh — explore our location in interactive 3D.'
    },
    location_welcome_title: {
        ar: 'حياك الله وتشرفنا وتسعدنا بزيارتك لنا في مكتبنا بمدينة الرياض',
        en: "Welcome — we'd be honored and delighted to have you visit our office in Riyadh"
    },
    location_discover_3d: {
        ar: 'اكتشف مقرنا بتقنية الخرائط 3D',
        en: 'Discover Our Location in 3D'
    },
    our_location_metro: {
        ar: 'محطة مترو وزارة التعليم',
        en: 'Ministry of Education Metro Station'
    },
    our_location_office: {
        ar: 'مقرنا',
        en: 'Our Office'
    },
    our_location_distance: {
        ar: 'المسافة من محطة المترو',
        en: 'Distance from the metro station'
    },
    follow_us: {
        ar: 'تابعنا',
        en: 'Follow Us'
    },
    share_location: {
        ar: 'شارك الموقع',
        en: 'Share Location'
    },
    link_copied: {
        ar: 'تم نسخ الرابط',
        en: 'Link Copied'
    },
    get_directions: {
        ar: 'احصل على الاتجاهات',
        en: 'Get Directions'
    },
    join_ojo: {
        ar: 'انضم إلى أوخو',
        en: 'Join OJO'
    },

    blog: {
        ar: 'المدونة',
        en: 'Blog'
    },
    blog_description: {
        ar: "اكتشف أفكار وإلهامات من فريقنا عن التصميم، التسويق، والعلامات التجارية. خلك على اطلاع دائم على آخر التوجهات والإبداعات في عالم الكرييتف.",
        en: "Explore insights, trends, and creative ideas from our team. Stay inspired and discover how innovation shapes the world of design, marketing, and branding."
    },
    contact: {
        ar: 'خلنا على تواصل',
        en: 'Contact Us'
    },



    contact_us_whatsapp: {
        ar: "خلنا على تواصل عبر الواتساب",
        en: "Reach us on WhatsApp"
    },
    contact_us_message: {
        ar: "نفزع لك او مهتم بخدماتنا تواصل معنا ومايصير خاطرك الا طيب",
        en: "We're here to assist you! Contact us and let's make it a great experience."
    },

    contact_us_message_1: {
        ar: "👋 أهلاً وسهلاً! نحن فريق أوخو - OJO، نساعدك تحوّل أفكارك لحلول إبداعية.",
        en: "👋 Hello and welcome! We are the OJO team, helping you turn ideas into creative solutions."
    },

    contact_us_message_2: {
        ar: "خلينا نكمل بشكل أسرع على واتساب، نقدر نجاوبك فوراً ونشاركك أفكارنا.",
        en: "We're here to help! Get in touch with us and let’s create something great together."
    },



    by_clicking_privacy: {
        ar: "بالضغط على زر “ارسال طلب” فإنك توافق على ",
        en: "By clicking the “Send Request” button, you agree to the "
    },

    features: {
        ar: "إيش اللي يميزنا عن غيرنا؟",
        en: "Features"
    },
    features_title: {
        ar: "ليش حنّا ؟",
        en: "Why Choose Us?"
    },

    partners: {
        ar: "شركاء وثقوا بنا",
        en: "Partners Who Trust Us"
    },
    partners_title: {
        ar: "حنا ما نقدم خدمات بس , هدفنا دايم نبني علاقات طويلة وناجحة بمبدأ المصداقية والشفافية مع عملاؤنا وشركاؤنا عشان ننجح سوا .",
        en: "We don't just offer services, our goal is to build long-term successful relationships based on credibility and transparency with our clients and partners."
    },

    blog: {
        ar: "المدونة",
        en: "Blog"
    },
    blog_title: {
        ar: "أحدث المقالات",
        en: "Latest Insights"
    },

    faq: {
        ar: "الأسئلة الشائعة",
        en: "Frequently Asked Questions"
    },
    faq_title: {
        ar: "عندك استفسارات اكثر ؟",
        en: "Have more questions?"
    },
    faq_description: {
        ar: "جمعنا لك أكثر الأسئلة الشائعة مع إجاباتها عشان تكون واضحة وسريعة .. ودنا دايم نسهل الرحلة والتجربة لكم",
        en: "We've gathered the most frequently asked questions with clear and quick answers to make it clear and quick. And we always make it easy for you."
    },


    learn_more: {
        ar: "إقرا كاملاُ",
        en: "Read More",
    },

    contact_us: {
        ar: "تواصل معنا",
        en: "Contact Us"
    },
    contact_us_title: {
        ar: "حنا هنا لخدمتك",
        en: "We're here to serve you"
    },
    contact_us_description: {
        ar: "سواءً كنت تحتاج معلومات اكثر او ودك تتعاون معنا او اي استفسار .. حياك الله تواصل معنا ومايصير خاطرك الا طيب",
        en: "Whether you need more information, want to collaborate, or have a question, our team is ready to respond with all the care. Feel free to contact us at any time."
    },

    name: {
        ar: "الاسم",
        en: "Name"
    },
    phone: {
        ar: "الهاتف",
        en: "Phone"
    },
    email: {
        ar: "البريد الإلكتروني",
        en: "Email"
    },
    company_name: {
        ar: "اسم الشركة",
        en: "Company Name"
    },
    select_services: {
        ar: "اختر الخدمة",
        en: "Select Services"
    },
    message: {
        ar: "الرسالة",
        en: "Message"
    },
    accept_terms: {
        ar: 'بالضغط على زر "ارسال" فإنك توافق على ',
        en: "By clicking the “Send Request” button, you agree to the "
    },
    send: {
        ar: "ابدأ مشروعك",
        en: "Start Your Project"
    },


    how_it_works: {
        ar: "كيف تستفيد من خدماتنا ؟",
        en: "How to Benefit from Our Services?"
    },

    how_it_works_description: {
        ar: "بسطنا رحلة الإعلانات مع  المؤثرين. سواءً كنت بتطلق منتج جديد أو تسعى لظهور علامتك التجارية بتفاعل قوي ورهيب.",
        en: "We've simplified the process of influencer marketing. Whether you're launching a product or growing your brand, our step-by-step workflow ensures your campaign is efficient, targeted, and results-driven."
    },
    how_it_works_description_2: {
        ar: "خبرتنا وخطواتنا والقاعدة اللي نملكها نضمن لك حملة فعّالة وموجهة لفئتك المستهدفة تحقق نتائج حقيقي",
        en: "Our experience and steps and the foundation we have ensure an effective and targeted campaign for your target audience that achieves real results."
    },



    know_more_about_service: {
        ar: "الإعلانات مع المؤثرين",
        en: "Influencer Marketing"
    },
    more_about_us: {
        ar: "تعرف علينا اكثر",
        en: "More about us"
    },

    what_client_say: {
        ar: "ماذا يقول عنا عملاؤنا",
        en: "Testimonials"
    },

    stats: {
        ar: "أثرنا بالأرقام",
        en: "Our Impact in Numbers"
    },
    stats_description: {
        ar: "هذه ليست أرقام هذه محطات، إنجازات، قصص نجاح",
        en: "These aren't just numbers - they're milestones, achievements, and success stories."
    },

    about_stats_heading: {
        ar: "في زمن تتكاثر فيها الأفكار وتتشابه الأصوات\nيظل هناك من يعرف كيف يصنع أثراً",
        en: "In a time when ideas multiply and voices start to sound the same,\nsome still know how to make an impact."
    },
    about_stats_note_title: {
        ar: "ليست أرقاماً فقط",
        en: "Not just numbers"
    },
    about_stats_note_text: {
        ar: "محطات، إنجازات، قصص نجاح، والأهم وعود تنفّذ قبل ان تُكتب",
        en: "Milestones, achievements, success stories, and most importantly, promises delivered before they are even written"
    },

    order_now: {
        ar: "عشان ننجح سوا  تواصل معنا : )",
        en: "Let's Succeed Together : )"
    },

    cta_slogan_description: {
        ar: "حتى لو كتبناها بالانجليزي – ترى ماعندنا مكتب خارج السعودية يكتب لك محتوى : )",
        en: "Even written in English — we don't outsource your content to an office outside Saudi : )"
    },

    // Footer

    privacy_policy: {
        ar: "سياسة الخصوصية",
        en: "Privacy Policy"
    },

    commercial_registration_number: {
        ar: "السجل التجاري",
        en: "CRN"
    },
    tax_number: {
        ar: "الرقم الضريبي",
        en: "TIN"
    },
    all_rights_reserved: {
        ar: "جميع الحقوق محفوظة",
        en: "All Rights Reserved"
    },

    // blog seo
    blog_seo_title: {
        ar: "المدونة",
        en: "Blog"
    },
    blog_seo_description: {
        ar: "خلّك دايم في الصورة مع أحدث المقالات والنصايح عن الاعلانات مع المؤثرين والنمو وأخبار المجال. محتوى يلهمك ويساعدك تطوّر براندك وتوصل لأحسن النتائج!",
        en: "Stay ahead with the latest articles and tips on influencer marketing, growth strategies, and industry news. Inspiring content to help you develop your brand and achieve better results!"
    },
    blog_seo_keywords: {
        ar: "اعلانات مع المؤثرين, استراتيجيات النمو, أخبار الصناعة , اعلانات مع المؤثرين , استراتيجيات النمو , أخبار الصناعة , اعلانات مع المؤثرين , استراتيجيات النمو , أخبار الصناعة",
        en: "Influencer Marketing, Growth Strategies, Industry News, Influencer Marketing, Growth Strategies, Industry News, Influencer Marketing, Growth Strategies, Industry News"
    },

    blog_not_found: {
        ar: "المقالة غير موجودة",
        en: "The article was not found"
    },


    success_request: {
        ar: "شكرا لك على مراسلتنا",
        en: "Thank you for contacting us"
    },
    we_will_contact_you_soon: {
        ar: "سيتم التواصل معك قريباً لمعرفة المزيد عن طلبك",
        en: "We will contact you soon to discuss your request in more detail"
    },
    ok: {
        ar: "موافق",
        en: "OK"
    },

    // faq seo
    faq_seo_title: {
        ar: "الأسئلة الشائعة",
        en: "Frequently Asked Questions"
    },
    faq_seo_description: {
        ar: "هل لديك سؤال؟ جمعنا لك أكثر الأسئلة شيوعًا مع إجابات واضحة وسريعة. تصفح القسم لتجد ما تحتاج إليه بسهولة.",
        en: "Have a question? We've gathered the most frequently asked questions with clear and quick answers. Browse the section to easily find what you need."
    },
    faq_seo_keywords: {
        ar: "الأسئلة الشائعة, الأسئلة الشائعة, الأسئلة الشائعة, الأسئلة الشائعة, الأسئلة الشائعة, الأسئلة الشائعة, الأسئلة الشائعة",
        en: "Frequently Asked Questions, Frequently Asked Questions, Frequently Asked Questions, Frequently Asked Questions, Frequently Asked Questions, Frequently Asked Questions, Frequently Asked Questions"
    },
    tiktok: {
        ar: "تيكتوك",
        en: "TikTok"
    },
    linkedin: {
        ar: "لينكدين",
        en: "LinkedIn"
    },
    instagram: {
        ar: "انستقرام",
        en: "Instagram"
    },
    x: {
        ar: "إكس",
        en: "X"
    },
    watch_more: {
        ar: "شوف المزيد",
        en: "Watch More"
    },

    our_vision: {
        ar: "رؤيتنا",
        en: "Our Vision"
    },
    our_goals: {
        ar: "أهدافنا",
        en: "Our Goals"
    },

    our_direction: {
        ar: "كيف نفكر ؟",
        en: "How We Think?"
    },

    end: {
        ar: "نهاية المقال",
        en: "Blog End"
    },
    company: {
        ar: "الشركة",
        en: "Company"
    },

    contact_title: {
        ar: "التواصل",
        en: "Contact Info"
    },

    contact_form_tagline_start: {
        ar: "عندك مشروع تبي نكتشف فرص النمو؟",
        en: "Have a project you'd like us to uncover growth opportunities for?"
    },
    contact_form_tagline_highlight: {
        ar: "اقدم وحنّا معك",
        en: "Step forward, we're with you"
    },
    contact_form_body: {
        ar: "شاركنا تحديك، ونبدأ من فهم المشكلة ونعطيك حلول لها بخبرات متراكمة.",
        en: "Share your challenge with us, and we'll start by understanding the problem then hand you solutions backed by proven expertise."
    },
    contact_form_intro_question: {
        ar: "وش حاب نشتغل عليه معك؟",
        en: "What would you like us to work on together?"
    },
    project_type: {
        ar: "نوع المشروع",
        en: "Project Type"
    },
    select_project_type: {
        ar: "اختر نوع المشروع",
        en: "Select project type"
    },
    project_type_influencer: {
        ar: "حملة تسويق بالمؤثرين",
        en: "Influencer Marketing Campaign"
    },
    project_type_branding: {
        ar: "هوية بصرية / براندنج",
        en: "Branding / Visual Identity"
    },
    project_type_social: {
        ar: "إدارة حسابات التواصل الاجتماعي",
        en: "Social Media Management"
    },
    project_type_content: {
        ar: "إنتاج محتوى وفيديو",
        en: "Content & Video Production"
    },
    project_type_other: {
        ar: "أخرى",
        en: "Other"
    },
    budget: {
        ar: "الميزانية التقريبية",
        en: "Approximate Budget"
    },
    select_budget: {
        ar: "اختر الميزانية التقريبية (اختياري)",
        en: "Select approximate budget (optional)"
    },
    budget_under_10k: {
        ar: "أقل من 10,000 ريال",
        en: "Under SAR 10,000"
    },
    budget_10k_30k: {
        ar: "10,000 - 30,000 ريال",
        en: "SAR 10,000 - 30,000"
    },
    budget_30k_100k: {
        ar: "30,000 - 100,000 ريال",
        en: "SAR 30,000 - 100,000"
    },
    budget_over_100k: {
        ar: "أكثر من 100,000 ريال",
        en: "Over SAR 100,000"
    },
    budget_undecided: {
        ar: "غير محدد بعد",
        en: "Not decided yet"
    },
    expected_response_time: {
        ar: "عادةً نرد خلال 24 ساعة عمل",
        en: "We usually respond within 24 business hours"
    },
    contact_form_privacy_note: {
        ar: "معلوماتك بأمان معنا، ولن تُستخدم إلا للتواصل معك بخصوص طلبك.",
        en: "Your information is safe with us and will only be used to get in touch about your request."
    },

    coming_soon: {
        ar: "قريباً",
        en: "Coming Soon"
    },
    coming_soon_description: {
        ar: "هذه الصفحة تحت التطوير حالياً، ترقبونا قريباً.",
        en: "This page is currently under development. Stay tuned."
    },
    back_to_home: {
        ar: "العودة للرئيسية",
        en: "Back to Home"
    },

    toggle_menu: {
        ar: "فتح/إغلاق القائمة",
        en: "Toggle menu"
    },
    close_menu: {
        ar: "إغلاق القائمة",
        en: "Close menu"
    },

}

const transs = {

    get(key, lang) {
        if (!data_locale[key]) {
            return key;
        }

        if (!data_locale[key][lang]) {
            return data_locale[key]['en'] || key;
        }

        return data_locale[key][lang];
    }
}

export { transs };
